import { StandardProps } from "@/components/componentMap";
import styles from "./EnergyLabelAndSaving.module.scss";
import { EnergyLabel } from "@/components/EnergyLabel/EnergyLabel.tsx";
import { EnergySaving } from "@/components/EnergySaving/EnergySaving.tsx";

export function EnergyLabelAndSaving({
  flags,
  product,
}: Pick<StandardProps, "product" | "flags">) {
  const enableNewEnergyAndYourekoLabels =
    flags.enableNewEnergyAndYourekoLabels.value === true;

  if (!enableNewEnergyAndYourekoLabels) return null;

  return (
    <div className={styles.wrapper}>
      <div className={styles.energyLabelWrapper}>
        <EnergyLabel
          product={product}
          flags={flags}
          configProps={{ energyComboMode: true }}
        />
      </div>
      <EnergySaving product={product} />
    </div>
  );
}
